import Vue from 'vue'
import Vuex from 'vuex'
import { globalTrackingStore } from '@/state/globalTrackingStore'
import { sideBarStore } from '@/state/sideBarStore'
import { layoutStore } from '@/state/layoutStore'
import { loginStore } from '@/state/loginStore'
import { profileStore } from '@/state/profileStore'
import { orderStore } from '@/state/orderStore'
import { recipientStore } from '@/state/recipientStore'
import { productStore } from '@/state/productStore'
import { teamStore } from '@/state/teamStore'
import { reportStore } from '@/state/reportStore'
import { billingStore } from '@/state/billingStore'
import { depositStore } from '@/state/depositStore'
import { modalStore } from '@/state/modalStore'
import { integrationStore } from '@/state/integrationStore'
import { notificationStore } from '@/state/notificationStore'
import { cardTemplateStore } from '@/state/cardTemplateStore'
import { inventoryStore } from '@/state/inventoryStore'
import { groupOrderStore } from '@/state/groupOrderStore'
import { subTeamsStore } from '@/state/subTeamsStore'
import { projectStore } from '@/state/projectStore'
import { eCommerceStore } from '@/state/eCommerceStore'
import { shopifyStore } from '@/state/shopifyStore'
import createPersistedState from 'vuex-persistedstate'
import _ from 'lodash'

Vue.use(Vuex)

const persistedState = createPersistedState({
  key: 'paigePersistedData',
  reducer: (state, paths) => {
    const existingSession = window.$cookies.get('recipient-session')
    if (!state.auth.auth['access-token'] && !existingSession) {
      return {}
    }
    return paths.reduce((substate, path) => {
      return _.set(substate, path, _.get(state, path))
    }, {})
  },
  paths: [
    'order.shoppingBagProducts',
    'order.selectedRecipientId',
    'order.recipientResourceType',
    'order.cardMessage',
    'order.selectedTemplateId',
    'order.currentOrderId',
    'order.salesforceResourceType',
    'order.salesforceResourceUID',
    'order.checkInventoryResponse',
    'recipient.newRecipient',
    'recipient.recipientList',
    'recipient.recipientErrors',
    'recipient.recipientListRecords',
    'recipient.recipientListDetails',
    'recipient.recipientType',
    'recipient.selectedRecipientList',
    'profile.user',
    'team.team',
    'integration.integrations',
    'layout.layout',
    'groupOrder.groupOrderDetails',
    'groupOrder.creatingGroupOrderStep',
    'groupOrder.groupOrderTiers',
    'groupOrder.recipient',
    'groupOrder.selectedVariants',
    'groupOrder.confirmWithSuccess',
    'billing.currentSubscription',
    'groupOrder.variantSelection',
    'inventory.requestEstimateCount',
    'inventory.stockThresholdValue',
    'project.recipientInfo'
  ]
})

export default new Vuex.Store({
  modules: {
    modal: modalStore,
    globalTracking: globalTrackingStore,
    sideBar: sideBarStore,
    layout: layoutStore,
    team: teamStore,
    order: orderStore,
    recipient: recipientStore,
    product: productStore,
    profile: profileStore,
    auth: loginStore,
    report: reportStore,
    billing: billingStore,
    deposit: depositStore,
    integration: integrationStore,
    notification: notificationStore,
    cardTemplate: cardTemplateStore,
    inventory: inventoryStore,
    groupOrder: groupOrderStore,
    subTeams: subTeamsStore,
    project: projectStore,
    ecommerce: eCommerceStore,
    shopify: shopifyStore
  },
  plugins: [persistedState]
})
